import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { useAppSelector } from '../../../redux/store';
import { ACCOUNT, SIGNUP_VERIFICATION } from '../../../routes/routeConstants';
import useHttps from '../../useHttps';

const useSignup = () => {
  const request = useHttps();
  const signUpData = useAppSelector((state) => state.signUpData);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSignUpError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Something went wrong');
  };

  const onSignUpSuccess = ({ data }: SuccessHttpResponse<any>) => {
    navigate(`/${ACCOUNT}/${SIGNUP_VERIFICATION}`, {
      replace: true,
      state: { data: data },
    });
  };

  const signup = () => {
    let { basicInfoSlider, moreInfoSlider, optionsSlider, passwordSlider } = signUpData;

    if (optionsSlider.accountCreatorRole !== 'RoleNotListed') {
      optionsSlider = { accountCreatorRole: optionsSlider.accountCreatorRole };
    }

    const url: HttpConfig = {
      url: 'api/v1/company/create-account',
      method: 'post',
      data: { ...basicInfoSlider, ...moreInfoSlider, ...optionsSlider, ...passwordSlider },
    };

    request(url, onSignUpSuccess, setLoading, onSignUpError);

  };

  return {
    loading,
    signup,
  };
};

export default useSignup;
